import purchaseOrderTypeService from "../../../../services/procurementService/purchaseOrderTypeService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERTYPES } from "../../../../utils/constants";
import { PurchaseOrderTypeInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";

const usePurchaseOrderTypeById = (id: string | undefined) =>
  useQuery<PurchaseOrderTypeInterface, Error>({
    queryKey: [`${CACHE_KEY_PURCHASEORDERTYPES}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, purchaseOrderTypeId] = queryKey;
      return purchaseOrderTypeService.GetById(purchaseOrderTypeId as string);
    },
    enabled: !!id,
  });

export default usePurchaseOrderTypeById;
